export default "__VITE_ASSET__BpJOERuA__"